import { Spinner } from '@/Domain/components/Shared/Spinner';
import { useUser } from '@/Domain/hooks/User/useUser.hook';
import { UserProfilePage } from '@/UI/User/UserProfile/UserProfile.page';

export const UserProfilePageLoader = () => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spinner className="text-primary h-7 w-7" />
      </div>
    );
  }

  return <UserProfilePage user={user!} />;
};
